const PAGE_TYPE_MAP: { [key: string]: string } = {
  pages: 'product_group',
  categories: 'category',
  brands: 'brand',
}

export default function useQueryHelper() {
  const { pageType } = useBaseRoutes()

  const queryFilterType = computed(() => {
    return PAGE_TYPE_MAP[pageType.value]
  })

  return {
    queryFilterType,
  }
}
